import clsx from 'clsx';
import { AuthApiError, defaultErrorMessages, resolveErrorMessage } from '../errors.js';
export const DEFAULT_FORM_CLASSES = {
    form: 'auth-ui-form',
    field: 'auth-ui-field',
    label: 'auth-ui-label',
    input: 'auth-ui-input',
    hint: 'auth-ui-hint',
    error: 'auth-ui-error',
    button: 'auth-ui-button',
    secondaryButton: 'auth-ui-button auth-ui-button-secondary',
    checkbox: 'auth-ui-checkbox',
    link: 'auth-ui-link',
    success: 'auth-ui-success',
};
/** Merge user overrides on top of the default class shell. */
export function mergeFormClasses(overrides) {
    if (overrides === undefined)
        return DEFAULT_FORM_CLASSES;
    return {
        form: clsx(DEFAULT_FORM_CLASSES.form, overrides.form),
        field: clsx(DEFAULT_FORM_CLASSES.field, overrides.field),
        label: clsx(DEFAULT_FORM_CLASSES.label, overrides.label),
        input: clsx(DEFAULT_FORM_CLASSES.input, overrides.input),
        hint: clsx(DEFAULT_FORM_CLASSES.hint, overrides.hint),
        error: clsx(DEFAULT_FORM_CLASSES.error, overrides.error),
        button: clsx(DEFAULT_FORM_CLASSES.button, overrides.button),
        secondaryButton: clsx(DEFAULT_FORM_CLASSES.secondaryButton, overrides.secondaryButton),
        checkbox: clsx(DEFAULT_FORM_CLASSES.checkbox, overrides.checkbox),
        link: clsx(DEFAULT_FORM_CLASSES.link, overrides.link),
        success: clsx(DEFAULT_FORM_CLASSES.success, overrides.success),
    };
}
/**
 * Picks the right user-facing string for a thrown error, optionally honoring
 * the host app's overrides. Returns null when there's no error to display.
 */
export function describeError(error, errorMessages) {
    if (error === null || error === undefined)
        return null;
    return resolveErrorMessage(error, { ...defaultErrorMessages, ...(errorMessages ?? {}) });
}
/**
 * Returns true when the error is an AuthApiError matching one of the supplied
 * codes. Components use this to highlight a specific field instead of the
 * whole-form error region.
 */
export function isErrorCode(error, ...codes) {
    return error instanceof AuthApiError && codes.includes(error.code);
}
//# sourceMappingURL=shared.js.map